import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Bar from '../../../components/RightSidebar/Bar';

import { toggleCustomerOnboardingPopup } from '../../../modules/customerOnboarding/actions';

const mapDispatchToProps = {
  toggleCustomerOnboardingPopup
};

function mapStateToProps(state) {
  return {
    multiplesAvailable: state.getIn(['multiples', 'available']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    sidebarContent: state.getIn(['rightSidebar', 'content']),
    sidebarVisible: state.getIn(['rightSidebar', 'visible']),
    highlightedButton: state.getIn(['rightSidebar', 'highlightedButton']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Bar));
